module.exports = __webpack_public_path__ + "static/img/r1.7dcad3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/r1.png
// module id = 5E5s
// module chunks = 1